import PortalIdParser from 'PortalIdParser';
import { parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import { getLocalizedHubSpotUrl } from 'marketplace-ui-common/utils/urls';
export function getConnectedAppsUrl() {
  const base = getFullUrl('app');
  return `${base}/integrations-settings/${PortalIdParser.get()}`;
}
export function getInstalledAppsUrl() {
  return `${getConnectedAppsUrl()}/installed`;
}

// shortlinks will always take you to the in-app details page
export function getAppDetailsShortlink(slug) {
  return `${getFullUrl('app')}/l/ecosystem/marketplace/apps/${slug}`;
}
export function getPublicAppDetailsUrl(slug) {
  return `${getFullUrl('ecosystem')}/marketplace/apps/${slug}`;
}
export function getAppDetailsUrl(appContext, slug) {
  return appContext === 'app' ? getAppDetailsShortlink(slug) : getPublicAppDetailsUrl(slug);
}
export const getDataSyncProductUrl = (lang = 'en') => `${getLocalizedHubSpotUrl(lang)}/products/data-sync`;
export const getFormattedUrl = href => {
  if (!href) return '';
  const {
    protocol
  } = parseUrl(href);
  return !protocol ? `http://${href}` : href;
};